export default "__VITE_ASSET__BsWRp4Ni__"